(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const mount = (root) => root.querySelectorAll('[data-ambient-video]').forEach(video => {
    if (video.dataset.ambientBound) return;
    video.dataset.ambientBound = 'true';
    const host = video.closest('.ambient-scene-host');
    const button = host?.querySelector('[data-ambient-toggle]');
    if (!host || !button) return;
    let visible = false, userPaused = false, optedIn = false;
    const library = host.closest('[data-living-library]');
    const permitted = () => visible && !document.hidden && !userPaused && !library?.classList.contains('is-book-active') && (optedIn || (!motion.matches && !navigator.connection?.saveData));
    const updateButton = () => {
      const playing = !video.paused;
      button.textContent = playing ? 'Pause animation' : 'Play animation';
      button.setAttribute('aria-label', playing ? 'Pause background animation' : 'Play background animation');
      button.setAttribute('aria-pressed', String(playing));
    };
    const sync = () => {
      if (!permitted()) { video.pause(); updateButton(); return; }
      video.muted = true;
      video.defaultMuted = true;
      if (!video.hasAttribute('src')) { video.src = video.dataset.src; video.load(); }
      const attempt = video.play();
      attempt?.then(() => { if (!permitted()) video.pause(); updateButton(); }).catch(updateButton);
    };
    button.hidden = false;
    button.addEventListener('click', () => {
      if (video.paused) { userPaused = false; optedIn = true; }
      else userPaused = true;
      sync();
    });
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('error', () => { video.pause(); button.hidden = true; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: .05 }).observe(video);
    }
    // No observer: retain the static poster until explicitly requested.
    else { visible = true; userPaused = true; }
    document.addEventListener('visibilitychange', sync);
    motion.addEventListener?.('change', () => { optedIn = false; sync(); });
    if (library) new MutationObserver(sync).observe(library, { attributes:true, attributeFilter:['class'] });
  });
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
